import type { MenuConfig } from '~typings/menu'

import permisosContabilidadPg, { RESOURCE_CONTABILIDAD_PG } from '@/auth/permissions/modules/contabilidadPg'
import * as names from '@routes/contabilidad-pg/nombres/informes'

const { informes } = permisosContabilidadPg
export default [
    {
        title: 'contabilidad.informes.anexos.menu_title',
        fontIcon: 'sitemap',
        resource: RESOURCE_CONTABILIDAD_PG,
        action: informes.anexos,
        route: names.ROUTE_ANEXOS,
    },
    // {
    //     title: 'contabilidad.informes.anexos_fijos.menu_title',
    //     fontIcon: 'sitemap',
    //     resource: RESOURCE_CONTABILIDAD_PG,
    //     action: informes.anexosActivosFijos,
    //     route: names.ROUTE_ANEXOS_ACTIVOS_FIJOS,
    // },
    {
        title: 'contabilidad.informes.balance_comprobacion.menu_title',
        fontIcon: 'sitemap',
        resource: RESOURCE_CONTABILIDAD_PG,
        action: informes.balanceComprobacion,
        route: names.ROUTE_BALANCE_COMPROBACION,
    },
    {
        title: 'contabilidad.informes.balance_comprobacion_segmentado.menu_title',
        fontIcon: 'sitemap',
        resource: RESOURCE_CONTABILIDAD_PG,
        action: informes.balanceComprobacionSegmentado,
        route: names.ROUTE_BALANCE_COMPROBACION_SEGMENTADO,
    },
    {
        title: 'contabilidad.informes.balance_dinamico.menu_title',
        fontIcon: 'sitemap',
        resource: RESOURCE_CONTABILIDAD_PG,
        action: informes.balanceDinamico,
        route: names.ROUTE_BALANCE_DINAMICO,
    },
    {
        title: 'contabilidad.informes.balance_general.menu_title',
        fontIcon: 'sitemap',
        resource: RESOURCE_CONTABILIDAD_PG,
        action: informes.balanceGeneral,
        route: names.ROUTE_BALANCE_GENERAL,
    },
    {
        title: 'contabilidad.informes.conciliacion_cuentas.menu_title',
        fontIcon: 'sitemap',
        resource: RESOURCE_CONTABILIDAD_PG,
        action: informes.conciliacionCuentas,
        route: names.ROUTE_CONCILIACION_CUENTAS,
    },
    {
        title: 'contabilidad.informes.costo_empacadoras.title',
        fontIcon: 'sitemap',
        resource: RESOURCE_CONTABILIDAD_PG,
        action: informes.costoEmpacadoras,
        route: names.ROUTE_COSTO_EMPACADORAS,
    },
    {
        title: 'contabilidad.informes.costo_tilapiero.menu_title',
        fontIcon: 'sitemap',
        resource: RESOURCE_CONTABILIDAD_PG,
        action: informes.costoTilapiero,
        route: names.ROUTE_COSTO_TILAPIERO,
    },
    {
        title: 'contabilidad.informes.diario_general.menu_title',
        fontIcon: 'sitemap',
        resource: RESOURCE_CONTABILIDAD_PG,
        action: informes.diarioGeneral,
        route: names.ROUTE_DIARIO_GENERAL,
    },
    {
        title: 'contabilidad.informes.estado_financiero_segmentado.menu_title',
        fontIcon: 'sitemap',
        resource: RESOURCE_CONTABILIDAD_PG,
        action: informes.estadoFinancieroSegmentado,
        route: names.ROUTE_ESTADO_FINANCIERO_SEGMENTADO,
    },
    {
        title: 'contabilidad.informes.estado_pyg.menu_title',
        fontIcon: 'sitemap',
        resource: RESOURCE_CONTABILIDAD_PG,
        action: informes.estadoPyg,
        route: names.ROUTE_ESTADO_PYG,
    },
    {
        title: 'contabilidad.informes.indicadores.menu_title',
        fontIcon: 'sitemap',
        resource: RESOURCE_CONTABILIDAD_PG,
        action: informes.indicadores,
        route: names.ROUTE_INDICADORES,
    },
    {
        title: 'contabilidad.informes.mayor_general.menu_title',
        fontIcon: 'sitemap',
        resource: RESOURCE_CONTABILIDAD_PG,
        action: informes.mayorGeneral,
        route: names.ROUTE_MAYOR_GENERAL,
    },
    {
        title: 'contabilidad.informes.mayor_por_patrimonio.menu_title',
        fontIcon: 'sitemap',
        resource: RESOURCE_CONTABILIDAD_PG,
        action: informes.mayorPatrimonio,
        route: names.ROUTE_MAYOR_PATRIMONIO,
    },
    {
        title: 'contabilidad.informes.mayor_por_procesos.menu_title',
        fontIcon: 'sitemap',
        resource: RESOURCE_CONTABILIDAD_PG,
        action: informes.mayorProcesos,
        route: names.ROUTE_MAYOR_PROCESOS,
    },
    {
        title: 'contabilidad.informes.consulta_movimientos_contables.menu_title',
        fontIcon: 'sitemap',
        resource: RESOURCE_CONTABILIDAD_PG,
        action: informes.movimientosContables,
        route: names.ROUTE_MOVIMIENTOS_CONTABLES,
    },
    {
        title: 'contabilidad.informes.movimientosvyc.menu_title',
        fontIcon: 'sitemap',
        resource: RESOURCE_CONTABILIDAD_PG,
        action: informes.movimientosVentasCxC,
        route: names.ROUTE_MOVIMIENTOS_VENTAS_CXC,
    },
    {
        title: 'contabilidad.informes.plan_cuenta_cias.menu_title',
        fontIcon: 'sitemap',
        resource: RESOURCE_CONTABILIDAD_PG,
        action: informes.planCuentaCias,
        route: names.ROUTE_PLAN_CUENTA_CIAS,
    },
    {
        title: 'contabilidad.informes.plan_cuenta_niif.menu_title',
        fontIcon: 'sitemap',
        resource: RESOURCE_CONTABILIDAD_PG,
        action: informes.planCuentaNiif,
        route: names.ROUTE_PLAN_CUENTA_NIIF,
    },
    {
        title: 'contabilidad.informes.resumen_rentas.menu_title',
        fontIcon: 'sitemap',
        resource: RESOURCE_CONTABILIDAD_PG,
        action: informes.resumenRentas,
        route: names.ROUTE_RESUMEN_RENTAS,
    },
] as MenuConfig[]
